import * as DiscountCompanyApiActions from './company-discount-api.actions';
import * as DiscountCompanyPageActions from './company-discount-page.actions';

export { DiscountCompanyApiActions, DiscountCompanyPageActions };